import { Observable } from 'rxjs';
import httpService from './httpService';
import { ParentOrganization } from '../data/models/parent-organization.model';
import omit from 'lodash/omit';

class ParentOrganizationsService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_CLIENT_API_URL.trim();
  }

  public getParentOrganizations(): Observable<Array<ParentOrganization>> {
    const url = `${this.apiBase}/parentOrganizationSummaryList`;
    return httpService.getJSON(url);
  }

  public getParentOrganization(id: string): Observable<ParentOrganization> {
    const url = `${this.apiBase}/getParentOrganization?parentOrganizationBC=${id}`;
    return httpService.getJSON(url);
  }

  public createOrganization(
    organization: ParentOrganization,
  ): Observable<ParentOrganization> {
    const url = `${this.apiBase}/createParentOrganization`;
    return httpService.postJSON(url, organization);
  }

  public updateOrganization(
    organization: ParentOrganization,
  ): Observable<ParentOrganization> {
    const url = `${this.apiBase}/updateParentOrganization`;
    const sanitized = omit(organization, ['isInternal']);
    return httpService.postJSON(url, sanitized);
  }
}

const parentOrganizationsService = new ParentOrganizationsService();

export default parentOrganizationsService;
